// extracted by mini-css-extract-plugin
module.exports = {"boxVideo":"video-gallery_boxVideo__TxrUo","playerFrame":"video-gallery_playerFrame__2HLNc"};